import React, {Component} from 'react';
import NavBar from "../Common/NavBar";
import TopMenu from "../Common/TopMenu";
import Toast from '../Common/Toast';
import API from '../../services/API';
import {toast} from "react-toastify";
import EmptyPic from "../../assets/images/emptypic.png";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {
    faCheck,
    faDownload,
    faUpload, faWallet
} from '@fortawesome/free-solid-svg-icons'
import {NavLink} from "react-router-dom";


class PersonProfile extends Component {
    state = {
        avatar: null,
        last_name: '',
        first_name: '',
        mobile: '',
        national_id: '',
        province: '',
        tel: '',
        description: '',
        city: '',
        email: '',
        file: null,
        pic: EmptyPic,
        provinces: [],
        cities: [],
        province_id: 0,
        city_id: 0,
        documents: [],
        document_file: null,
        document_description : '',
        document_title : '',
        password_check : '',
        profile_pass : '',
        show_password_dialog : true,
        is_marketer : 0
    }

    onFileChange = (event) => {
        let reader = new FileReader()
        reader.readAsDataURL(event.target.files[0])
        reader.onload = () => {
            this.setState({
                pic: reader.result,
                file: event.target.files[0]
            })
        };

    }
    onDocChange = (event) => {
        this.setState({
            document_file: event.target.files[0]
        })
    }
    onInputChange = (event) => {
        const inputName = event.target.name;
        const inputValue = event.target.value;
        this.setState({[inputName]: inputValue});

    }
    onProvinceChange = (event) => {
        const province_id = event.target.value;
        this.setState({province_id});
        API.cities(province_id)
            .then((response) => {
                this.setState({cities: response.results.cities})
            })
    }
    onPasswordVerifyClick  = () => {
        const pass = this.state.profile_pass;

        if(!pass) {
            if(this.state.password_check === '0000') {
                this.setState({
                    show_password_dialog : false,
                    profile_pass : ''
                })
            }
            else {
                toast.error('کلمه عبور وارد شده صحیح نمی باشد')
            }
        }
        else {
            if(this.state.password_check === pass) {
                this.setState({
                    show_password_dialog : false,
                    profile_pass : ''
                })
            }
            else {
                toast.error('کلمه عبور وارد شده صحیح نمی باشد')
            }
        }

    }
    onButtonClick = () => {
        const formData = new FormData();
        const file = this.state.file;
        if (file)
            formData.append('avatar', file);
        formData.append('last_name', this.state.last_name);
        formData.append('first_name', this.state.first_name);
        formData.append('national_id', this.state.national_id);
        formData.append('tel', this.state.tel);
        formData.append('email', this.state.email);
        formData.append('profile_pass', this.state.profile_pass);
        formData.append('province_id', this.state.province_id);
        formData.append('city_id', this.state.city_id);
        formData.append('phone_specification', navigator.userAgent);

        API.updateProfile(formData)
            .then((response) => {
                toast.success(response.user_message);
                setTimeout(() => {
                    this.props.history.push("/");
                }, 2000);
            })
            .catch((error) => {
                toast.error(error.response.data.user_message);
            });
    }
    onUploadClick = () => {
        const formData = new FormData();
        const file = this.state.document_file;
        if (file)
            formData.append('document_file', file);
        formData.append('document_title', this.state.document_title);
        formData.append('document_description', this.state.document_description);
        formData.append('last_name', this.state.last_name);

        API.updateProfile(formData)
            .then((response) => {
                toast.success(response.user_message);
                API.profile()
                    .then((response) => {
                        this.setState(response.results.user);
                        this.setState({
                            document_file : [],
                            document_title : '',
                            document_description: ''
                        })
                    })
            })
            .catch((error) => {
                toast.error(error.response.data.user_message);
            });
    }

    render() {
        let is_verified = 1;
        if(typeof (this.state.user_groups_global) !== 'undefined') {
            is_verified = this.state.user_groups_global[0].is_verified;
        }

        return (
            <React.Fragment>
                <Toast/>

                <section className="container-fluid rtl ">
                    <div className="row">
                        <div className="col-md-3 px-2">
                            <NavBar/>
                        </div>

                        <div className="col-md-9">
                            <TopMenu/>
                            {
                                this.state.show_password_dialog &&
                                <section className='container-fluid rtl profile-password pt-4'>
                                    <div className="row mt-4">
                                        <div className="col-md-3">&nbsp;</div>

                                        <div className="col-md-6">
                                            <div className="login-wrap py-5">
                                                <div className="img d-flex align-items-center justify-content-center"
                                                >
                                                    <img alt="Avatar"
                                                         src={(this.state.avatar && !this.state.file) ? this.state.avatar : this.state.pic }
                                                         width={64} className='rounded-circle'/>
                                                </div>
                                                <h3 className="text-center mb-0">
                                                    {this.state.last_name}
                                                    &nbsp;
                                                    عزیز
                                                    خوش آمدید
                                                </h3>
                                                <p className="text-center text-warning mt-2">
                                                    برای ورود به بخش پروفایل و اطلاعات کاربری لطفا گذرواژه تعیین شده خود را وارد کنید
                                                </p>
                                                <span action="#" className="login-form">
                                                <div className="form-group">
                                                    <div
                                                        className="icon d-flex align-items-center justify-content-center">
                                                        <span className="fa fa-lock"></span></div>
                                                    <input type="password" className="form-control"
                                                           placeholder="کلمه عبور"
                                                           id="password_check" name="password_check"
                                                           value={this.state.password_check}
                                                           onChange={this.onInputChange}
                                                    />
                                                </div>
                                                <div className="form-group mt-3">
                                                    <button
                                                        className="btn form-control btn-primary rounded submit px-3"
                                                        onClick={this.onPasswordVerifyClick}
                                                    >
                                                        تایید
                                                    </button>
                                                </div>
                                            </span>
                                                <div className="w-100 text-center mt-4 text super-small mt-3">
                                                    <p className="mb-0">
                                                        در صورتی که پیش از این برای خود کلمه عبوری تعیین نکرده اید، کلمه عبور پیش فرض
                                                        <strong className='mx-2 text-danger text-big' >0000</strong>
                                                        می باشد.
                                                    </p>
                                                    <div className="mt-5 text-info pointer"
                                                    onClick={() => {window.location.replace('/home')}}
                                                    >
                                                        انصراف و بازگشت
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-3">&nbsp;</div>
                                    </div>

                                </section>
                            }

                            <div className="text-center my-5 text-secondary">
                                {
                                    is_verified < 1 ?
                                        <div className="alert alert-danger m-3 small text-center">
                                            حساب کاربری شما هنوز تایید نشده است و نمی توانید درخواستی در سامانه ثبت کنید،
                                            <div>
                                                برای تایید حساب کاربری مشخصات خود را  کامل کرده و منتظر تایید مدیر سامانه بمانید.
                                            </div>

                                        </div>
                                        : ''}

                                <h2>
                                    <strong>ویرایش مشخصات کاربری</strong>
                                </h2>

                            </div>
                            <ul className="nav nav-tabs" id="myTab" role="tablist">
                                <li className="nav-item">
                                    <a className="nav-link active" id="home-tab" data-toggle="tab" href="#home"
                                       role="tab" aria-controls="home" aria-selected="true">اطلاعات شخصی</a>
                                </li>
                                <li className="nav-item">
                                    <a className="nav-link" id="profile-tab" data-toggle="tab" href="#profile"
                                       role="tab" aria-controls="profile" aria-selected="false">مستندات</a>
                                </li>

                            </ul>
                            <div className="tab-content" id="myTabContent">
                                <div className="tab-pane fade show active" id="home" role="tabpanel"
                                     aria-labelledby="home-tab">
                                    <section className="container rtl  p-3 usual-content ">
                                        <div className="row">

                                            <div className="col-12 p-5">

                                                <img alt="Avatar"
                                                     src={(this.state.avatar && !this.state.file) ? this.state.avatar : this.state.pic }
                                                     width={64} className='rounded-circle'/>
                                                <span className="px-5">
                                                <label className="custom-file-upload">
                                                    انتخاب تصویر پروفایل جدید
                                                 <input type="file" onChange={this.onFileChange}/>
                                                </label>
                                            </span>
                                                {
                                                    this.state.is_marketer === 1 &&

                                                    <NavLink className=" nav-link  float-left text-secondary" to="/wallet">
                                                        <FontAwesomeIcon icon={faWallet}/>
                                                        <span className="px-3">
                                                        مشاهده کیف پول
                                                        </span>
                                                    </NavLink>
                                                }
                                            </div>

                                            <div className="form-floating col-md-6 mt-4">
                                                <input type="text"
                                                       className="form-control px-5"
                                                       id="first_name" name="first_name"
                                                       placeholder="نام"
                                                       value={this.state.first_name}
                                                       onChange={this.onInputChange}/>
                                                <label htmlFor="first_name" className="super-small">نام</label>
                                            </div>
                                            <div className="form-floating col-md-6 mt-4">
                                                <input type="text"
                                                       className="form-control px-5"
                                                       id="last_name" name="last_name"
                                                       placeholder="نام خانوادگی"
                                                       value={this.state.last_name}
                                                       onChange={this.onInputChange}/>
                                                <label htmlFor="last_name" className="super-small">نام خانوادگی</label>
                                            </div>
                                            <div className="form-floating col-md-6 mt-4">
                                                <input type="text"
                                                       className="form-control px-5"
                                                       id="mobile" name="mobile"
                                                       placeholder="شماره موبایل"
                                                       value={this.state.mobile}
                                                       disabled
                                                />
                                                <label htmlFor="mobile" className="super-small">شماره موبایل</label>
                                            </div>
                                            <div className="form-floating col-md-6 mt-4">
                                                <input type="text"
                                                       className="form-control px-5"
                                                       id="national_id" name="national_id"
                                                       placeholder="کد ملی"
                                                       value={this.state.national_id ? this.state.national_id : ''}
                                                       onChange={this.onInputChange}
                                                />
                                                <label htmlFor="national_id" className="super-small">کد ملی</label>
                                            </div>
                                        </div>
                                    </section>
                                    <section className="container rtl mt-5 p-3 usual-content ">
                                        <div className="row">
                                            <div className="form-floating col-md-6 mt-4">
                                                <input type="email"
                                                       className="form-control px-5"
                                                       id="email" name="email"
                                                       placeholder="آدرس ایمیل"
                                                       value={this.state.email ? this.state.email : ''}
                                                       onChange={this.onInputChange}
                                                />
                                                <label htmlFor="email" className="super-small">آدرس ایمیل</label>
                                            </div>
                                            <div className="form-floating col-md-6 mt-4">
                                                <input type="tel"
                                                       className="form-control px-5"
                                                       id="tel" name="tel"
                                                       placeholder="شماره تماس ثابت"
                                                       value={this.state.tel ? this.state.tel : ''}
                                                       onChange={this.onInputChange}
                                                />
                                                <label htmlFor="tel" className="super-small">شماره تماس ثابت</label>
                                            </div>
                                            <div className="form-floating col-md-6 mt-4">
                                                <select className="form-select" id="province_id" name="province_id"
                                                        aria-label="Floating label select example"
                                                        value={this.state.province_id}
                                                        onChange={this.onProvinceChange}>
                                                    {this.state.provinces.map(pr => {
                                                        return (
                                                            <option value={pr.id} key={pr.id}>
                                                                {pr.title}
                                                            </option>
                                                        )
                                                    })}
                                                </select>
                                                <label htmlFor="province_id" className="super-small">استان</label>
                                            </div>
                                            <div className="form-floating col-md-6 mt-4">
                                                <select className="form-select" id="city_id" name="city_id"
                                                        aria-label="Floating label select example"
                                                        value={this.state.city_id}
                                                        onChange={this.onInputChange}
                                                >

                                                    {this.state.cities.map(ct => {
                                                        return (
                                                            <option value={ct.id} key={ct.id}>
                                                                {ct.title}
                                                            </option>
                                                        )
                                                    })}
                                                </select>
                                                <label htmlFor="city_id" className="super-small">شهر</label>
                                            </div>
                                            <div className="form-floating col-6 mt-4">

                                        <textarea className="form-control"
                                                  placeholder="توضیحات"
                                                  id="description"
                                                  name="description"
                                                  value={this.state.description ? this.state.description : ''}
                                                  onChange={this.onInputChange}
                                        />

                                                <label htmlFor="description" className="super-small">توضیحات</label>
                                            </div>

                                            <div className="form-floating col-md-6 mt-4">
                                                <input type="password"
                                                       className="form-control px-5"
                                                       id="profile_pass" name="profile_pass"
                                                       placeholder="کلمه عبور"
                                                       value={this.state.profile_pass}
                                                       onChange={this.onInputChange}/>
                                                <label htmlFor="profile_pass" className="super-small">کلمه عبور</label>
                                            </div>
                                            {
                                                is_verified > 0 ?
                                                    <div className="alert col-12 alert-warning my-3 small text-center">
                                                        با ویرایش اطلاعات حساب کاربری شما موقتا از حالت تایید خارج خواهد شد تا
                                                        اطلاعات جدید توسط مدیر سامانه بررسی شود.

                                                    </div>
                                                    : ''}
                                            <div className="col-md-6">
                                                &nbsp;
                                            </div>
                                            <div className="col-md-6 text-left mt-3">
                                                <button className="btn btn-success p-2 w-100" onClick={this.onButtonClick}>
                                                    <FontAwesomeIcon icon={faCheck}/>

                                                    &nbsp;
                                                    ثبت ویرایش اطلاعات
                                                </button>
                                            </div>

                                        </div>
                                    </section>
                                </div>
                                <div className="tab-pane fade" id="profile" role="tabpanel"
                                     aria-labelledby="profile-tab">
                                    <section className="container rtl  p-3 usual-content ">
                                        <h2 className="text-center text-primary mb-4">
                                            مدیریت مستندات
                                        </h2>
                                        <div className="row  mx-md-5 p-md-5 mb-2 border rounded text-center pt-5">
                                            <div className="col-md-4 ">
                                                <label className="custom-file-upload">
                                                    انتخاب فایل
                                                    <input type="file" onChange={this.onDocChange}/>
                                                </label>
                                            </div>
                                            <div className="col-md-8 small mb-3 mt-2 text-secondary">
                                                لطفا مستندات خود را در قالب فایل هایی با پسوند
                                                .doc,
                                                .pdf,
                                                .jpg,
                                                .png
                                                ارسال فرمایید.
                                            </div>
                                            <div className="form-floating col-md-4 mt-2">
                                                <input type="text"
                                                       className="form-control px-5"
                                                       id="document_title" name="document_title"
                                                       placeholder="عنوان فایل"
                                                       value={this.state.document_title}
                                                       onChange={this.onInputChange}/>
                                                <label htmlFor="document_title" className="super-small">عنوان فایل</label>
                                            </div>
                                            <div className="form-floating col-md-8">

                                        <textarea className="form-control"
                                                  placeholder="توضیحات"
                                                  id="document_description"
                                                  name="document_description"
                                                  value={this.state.document_description ? this.state.document_description : ''}
                                                  onChange={this.onInputChange}
                                        />

                                                <label htmlFor="document_description" className="super-small">توضیحات</label>
                                            </div>
                                            <div className="col-md-6 text-warning mt-4 super-small">
                                                &nbsp;
                                                {
                                                    this.state.document_file ? this.state.document_file.name : ''
                                                }
                                            </div>
                                            <div className="col-md-6 text-left mt-3">
                                                <button className="btn btn-outline-success p-2 w-100" onClick={this.onUploadClick}>
                                                    <FontAwesomeIcon icon={faUpload}/>

                                                    &nbsp;
                                                    ارسال فایل
                                                </button>
                                            </div>
                                        </div>
                                        <div className="border rounded mx-md-5 p-md-5 pt-5">
                                            {
                                                this.state.documents.length  > 0 ?

                                                    <h3 className="small text-success text-center">
                                                        فایل های دریافت شده از سمت شما
                                                    </h3>
                                                    :
                                                    <h3 className="small text-danger text-center">
                                                        هنوز هیچ فایلی از سمت شما دریافت نشده است
                                                    </h3>
                                            }
                                            <div className='row text-center py-3 m-auto mt-2 transactions-header  '>
                                                <div className="col-3">عنوان</div>
                                                <div className="col-6">توضیحات</div>
                                                <div className="col-3">دانلود</div>

                                            </div>
                                            {
                                                this.state.documents.map(doc => {

                                                    return (
                                                        <div
                                                            className='row text-center text-dark py-3 m-auto mt-2 transactions-body  ' key={doc.id}>
                                                            <div className="col-3 fw-bold">
                                                                {doc.title}
                                                            </div>
                                                            <div className="col-6 super-small"> {doc.description}</div>
                                                            <div className="col-3 small">
                                                                <a href={doc.path} target="_blank" rel="noreferrer">
                                                                    <FontAwesomeIcon icon={faDownload}/>&nbsp;
                                                                    دانلود
                                                                </a>
                                                            </div>

                                                        </div>
                                                    )
                                                })


                                            }
                                        </div>
                                    </section>
                                </div>

                            </div>


                        </div>
                    </div>
                </section>

            </React.Fragment>
        );
    }

    componentDidMount = () => {
        API.profile()
            .then((response) => {
                this.setState(response.results.user)
                if (response.results.user.province) {
                    this.setState({
                        province_id: response.results.user.province.id,
                        city_id: response.results.user.city.id
                    })
                }

            })
        API.index()
            .then((response) => {
                const is_marketer = response.results.user.is_marketer;
                this.setState({is_marketer});
            })
        API.provinces(83)
            .then((response) => {
                this.setState({provinces: response.results.provinces})
            })

        API.cities(1824)
            .then((response) => {
                this.setState({cities: response.results.cities})
            })
    }
}

export default PersonProfile;